import browserDetect from "browser-detect";
import React from "react";
import ReactDOM from "react-dom";
import { SiteNavigation } from "./widgets/SiteNavigation";
import { SiteSearch } from "./widgets/SiteSearch";
import "./assets/style/global.css";
// import * as serviceWorker from './serviceWorker';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

function createWrapper(Component: any) {
  return (domElement: HTMLElement, props: object) =>
    ReactDOM.render(<Component {...props} />, domElement);
}

(window as any).SL = {
  SiteNavigation: createWrapper(SiteNavigation),
  SiteSearch: createWrapper(SiteSearch),
  browserDetect: browserDetect
};
